import React from 'react'
import { Box, Card, Group, Text, Title } from '@mantine/core'
import { usePricingVersionCache } from '../../../../hooks/global-job-matching'
import { useParams } from 'react-router'
import { IconFile } from '@tabler/icons-react'

export const DefineStepDetails = () => {
  const params = useParams<{id: string}>()
  const version = usePricingVersionCache(params.id)
  const matchingMethod = version?.matchStrategy === 'current' ? 'Current Matches' : 'Match Priorities'

  return (
    <Box>
      <Title order={3} c='black'>Define</Title>
      <Text c='black' size='sm'>Set to use <Text span fw='bold' c='black' size='sm'>{matchingMethod}</Text></Text>
      <Text size='sm'>The matches in Market Price a Job</Text>
      { version.matchStrategy === 'file' && !version.metadata?.filename &&
        <Text c='red' fw='bold'>Upload Match Priority File is Required</Text>
      }
      { version?.matchStrategy === 'file' && version.metadata?.filename &&
      <>
        <Text c='black'>Match priority file</Text>
        <Card withBorder>
          <Group wrap='nowrap'>
            <IconFile />
            <Text fw='bold' c='black' size='sm'>{version.metadata?.filename}</Text>
          </Group>
        </Card>
      </>
      }
    </Box>
  )
}
